export default __webpack_public_path__ + "static/media/who-we-are-Header-HD.99e1f949.jpg";